export const TABLE_LIST_MASTER_DATA = {
  PRENAME: {
    NAME_LABEL: 'คำนำหน้าชื่อ',
    TABLE: 'MasterPreName',
  },
  SETTING: {
    NAME_LABEL: 'พื้นที่ดำเนินการ',
    TABLE: 'MasterSetting',
  },
  TARGET: {
    NAME_LABEL: 'กลุ่มเป้าหมายดำเนินการ',
    TABLE: 'MasterTarget',
  },
  ISSUE: {
    NAME_LABEL: 'ประเด็น',
    TABLE: 'MasterIssue',
  },
  LAW_TYPE: {
    NAME_LABEL: 'ประเภทคดี',
    TABLE: 'MasterLawType',
  },
  LAW_STATUS: {
    NAME_LABEL: 'สถานะทางกฎหมาย',
    TABLE: 'MasterLawStatus',
  },
  LOCATION_TYPE: {
    NAME_LABEL: 'ประเภทพื้นที่ดำเนินการ',
    TABLE: 'MasterLocationType',
  },
  STRATEGY_OF_THAIHEALTH_PLAN: {
    NAME_LABEL: 'แผนงาน',
    TABLE: 'MasterStrategyOfThaihealthPlan',
  },
}

// [MasterPreName]
// [MasterSetting]
// [MasterTarget]
// [MasterIssue]
// [MasterLawType]
// [MasterLawStatus]
// [MasterLocationType]
// MasterStrategyOfThaihealthPlan
